/* Latest Products carousel — client-side product scan.
   Runs against /products.json (or /collections/{handle}/products.json when
   scoped to a collection) instead of Liquid's collection.products, which is
   hard-capped at 250 items per render. Paging through the JSON endpoint has
   no such cap, so the true newest product always gets found, no matter how
   large the catalog grows. */
(function () {
  function formatMoney(cents, format) {
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimalSep) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = typeof thousands === 'undefined' ? ',' : thousands;
      decimalSep = typeof decimalSep === 'undefined' ? '.' : decimalSep;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimalSep + parts[1] : '';
      return dollars + centsPart;
    }

    var match = formatString.match(placeholderRegex);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return match ? formatString.replace(placeholderRegex, value) : formatString + value;
  }

  function appendImageSize(src, width) {
    if (!src) return src;
    var queryIndex = src.indexOf('?');
    var base = queryIndex > -1 ? src.slice(0, queryIndex) : src;
    var query = queryIndex > -1 ? src.slice(queryIndex) : '';
    var extDot = base.lastIndexOf('.');
    if (extDot === -1) return src;
    return base.slice(0, extDot) + '_' + width + 'x' + base.slice(extDot) + query;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  async function fetchAllProducts(collectionHandle) {
    var base = collectionHandle
      ? '/collections/' + collectionHandle + '/products.json'
      : '/products.json';
    var all = [];
    for (var page = 1; page <= 40; page++) {
      var res = await fetch(base + '?limit=250&page=' + page);
      if (!res.ok) break;
      var data = await res.json();
      if (!data.products || data.products.length === 0) break;
      all = all.concat(data.products);
      if (data.products.length < 250) break;
    }
    return all;
  }

  function pickVariant(p) {
    // Prefer a variant that's actually on sale (compare_at > price); fall
    // back to the first variant otherwise.
    var variants = p.variants || [];
    var best = null;
    variants.forEach(function (v) {
      var price = parseFloat(v.price);
      var compare = v.compare_at_price ? parseFloat(v.compare_at_price) : null;
      if (compare && compare > price) {
        if (!best) best = v;
      }
    });
    return best || variants[0] || null;
  }

  function buildCard(p, settings, newCutoff) {
    var variant = pickVariant(p);
    if (!variant) return '';
    var price = parseFloat(variant.price);
    var compare = variant.compare_at_price ? parseFloat(variant.compare_at_price) : null;
    var onSale = compare && compare > price;
    var isNew = new Date(p.created_at).getTime() > newCutoff;

    var image = p.images && p.images[0] ? p.images[0].src : null;
    var hoverImage = p.images && p.images[1] ? p.images[1].src : null;

    var img = image
      ? '<img class="rl-card__image" src="' +
        escapeHtml(appendImageSize(image, 800)) +
        '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="800" height="800">'
      : '';
    var hoverImg = hoverImage
      ? '<img class="rl-card__image rl-card__image--hover" src="' +
        escapeHtml(appendImageSize(hoverImage, 800)) +
        '" alt="" loading="lazy" width="800" height="800">'
      : '';

    var badge = '';
    if (settings.showBadge) {
      if (onSale) {
        badge = '<span class="rl-badge">' + escapeHtml(settings.saleBadgeLabel) + '</span>';
      } else if (isNew) {
        badge = '<span class="rl-badge rl-badge--new">' + escapeHtml(settings.newBadgeLabel) + '</span>';
      }
    }

    var vendor = settings.showVendor
      ? '<p class="rl-card__vendor">' + escapeHtml(p.vendor) + '</p>'
      : '';

    var titleClass = 'rl-card__title' + (settings.uppercase ? ' rl-uppercase' : '');

    var priceHtml = '';
    if (settings.showPrice) {
      if (onSale) {
        priceHtml =
          '<p class="rl-card__price">' +
            '<span class="rl-card__price--sale">' + formatMoney(Math.round(price * 100), settings.moneyFormat) + '</span>' +
            '<span class="rl-card__price--compare">' + formatMoney(Math.round(compare * 100), settings.moneyFormat) + '</span>' +
          '</p>';
      } else {
        priceHtml = '<p class="rl-card__price"><span>' + formatMoney(Math.round(price * 100), settings.moneyFormat) + '</span></p>';
      }
    }

    return (
      '<li class="rl-card">' +
        '<a href="/products/' + escapeHtml(p.handle) + '" class="rl-card__link">' +
          '<div class="rl-card__image-wrap rl-ratio-' + escapeHtml(settings.ratio) + '">' +
            img + hoverImg + badge +
          '</div>' +
          '<div class="rl-card__info">' +
            vendor +
            '<p class="' + titleClass + '">' + escapeHtml(p.title) + '</p>' +
            priceHtml +
          '</div>' +
        '</a>' +
      '</li>'
    );
  }

  function initCarousel(root) {
    var track = root.querySelector('.rl-latest__track');
    var prevBtn = root.querySelector('.rl-arrow--prev');
    var nextBtn = root.querySelector('.rl-arrow--next');
    var dotsWrap = root.querySelector('.rl-dots');
    var autoplay = root.dataset.autoplay === 'true';
    var speed = parseFloat(root.dataset.speed) || 35; // px per second
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function cardStep() {
      var card = track.querySelector('.rl-card');
      if (!card) return 300;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 0);
      return card.getBoundingClientRect().width + gap;
    }

    if (prevBtn && !prevBtn.dataset.rlBound) {
      prevBtn.dataset.rlBound = '1';
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
    }
    if (nextBtn && !nextBtn.dataset.rlBound) {
      nextBtn.dataset.rlBound = '1';
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var cards = track.querySelectorAll('.rl-card');
      cards.forEach(function () {
        var dot = document.createElement('span');
        dot.className = 'rl-dot';
        dotsWrap.appendChild(dot);
      });
    }
    function updateDots() {
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.rl-dot');
      if (!dots.length) return;
      var progress = track.scrollLeft / (track.scrollWidth - track.clientWidth || 1);
      var active = Math.round(progress * (dots.length - 1));
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === active);
      });
    }
    buildDots();
    if (!track.dataset.rlScrollBound) {
      track.dataset.rlScrollBound = '1';
      track.addEventListener('scroll', updateDots, { passive: true });
    }
    updateDots();

    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    var rafId = null;
    var paused = false;
    var resumeTimer = null;
    var lastTs = null;

    function step(ts) {
      if (paused) { lastTs = ts; rafId = requestAnimationFrame(step); return; }
      if (lastTs === null) lastTs = ts;
      var dt = (ts - lastTs) / 1000;
      lastTs = ts;
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 0) { rafId = requestAnimationFrame(step); return; }
      var next = track.scrollLeft + speed * dt;
      if (next >= max) {
        next = 0;
        track.scrollTo({ left: next });
      } else {
        track.scrollLeft = next;
      }
      rafId = requestAnimationFrame(step);
    }

    function pauseNow() {
      paused = true;
      clearTimeout(resumeTimer);
    }

    function resumeSoon() {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        paused = false;
        lastTs = null;
      }, 400);
    }

    if (autoplay && isMobile && !reduceMotion && !root.dataset.rlAutoplayBound) {
      root.dataset.rlAutoplayBound = '1';
      track.addEventListener('touchstart', pauseNow, { passive: true });
      track.addEventListener('pointerdown', pauseNow, { passive: true });
      track.addEventListener('touchend', resumeSoon, { passive: true });
      track.addEventListener('touchcancel', resumeSoon, { passive: true });
      track.addEventListener('pointerup', resumeSoon, { passive: true });
      track.addEventListener('pointercancel', resumeSoon, { passive: true });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (!rafId) rafId = requestAnimationFrame(step);
          } else if (rafId) {
            cancelAnimationFrame(rafId);
            rafId = null;
            lastTs = null;
          }
        });
      }, { threshold: 0.15 });
      io.observe(root);
    }
  }

  function renderSection(root) {
    var sectionId = root.getAttribute('data-rl-section-id');
    var settingsEl = document.querySelector('[data-rl-settings="' + sectionId + '"]');
    var track = document.querySelector('[data-rl-track="' + sectionId + '"]');
    if (!settingsEl || !track) return;

    var settings;
    try {
      settings = JSON.parse(settingsEl.textContent);
    } catch (e) {
      return;
    }

    fetchAllProducts(settings.collectionHandle)
      .then(function (products) {
        if (!products.length) return; // leave the placeholder cards in place

        products.sort(function (a, b) {
          return new Date(b.created_at) - new Date(a.created_at);
        });

        var limit = parseInt(settings.limit, 10) || 12;
        var displayProducts = products.slice(0, limit);
        var newCutoff = Date.now() - 14 * 24 * 60 * 60 * 1000;

        var html = displayProducts
          .map(function (p) { return buildCard(p, settings, newCutoff); })
          .join('');

        if (html) {
          track.innerHTML = html;
        }

        initCarousel(root);
      })
      .catch(function (err) {
        console.error('Latest Products carousel failed to load products:', err);
      });
  }

  function initAll(context) {
    (context || document).querySelectorAll('[data-rl-root]').forEach(renderSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Re-run when the theme editor re-renders this section (live settings preview).
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector && event.target.querySelector('[data-rl-root]');
    if (root) renderSection(root);
  });
})();
